import { trunc } from "@trinity/chat-components/utils";

export type FormatAxisLabelOptions = {
  value: string | number;
  unit?: string;
  isPrefix?: boolean;
};

export function formatAxisLabel({ value, unit, isPrefix }: FormatAxisLabelOptions): string {
  let formattedValue = trunc(String(value), 10);

  if (unit) {
    formattedValue = isPrefix ? `${unit}${formattedValue}` : `${formattedValue}${unit}`;
  }

  return formattedValue;
}